import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { FaEyeSlash, FaDownload } from 'react-icons/fa';
import PageLoader from '../components/PageLoader';

const VerifiedCustomer = () => {
    // const [show, setShow] = useState(false);
    const [pageLoading] = useState(false);
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);

    const [customer, setCustomer] = useState([]);
    // const [selectedFile, setSelectedFile] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    // const [isLoading, setIsLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const date = new Date().toISOString().slice(0, 10); // Format: YYYY-MM-DD


    const customersPerPage = 50;

   
    const getAllCustomer = () => {
        axios.get(`${base_url}/api1/account/verifiedCustomerList`).then(
            (response) => {
                setCustomer(response.data.reverse());
            },
            (error) => {
                console.log(error);
            }
        );
    };
    useEffect(() => {
        getAllCustomer();
    }, []);

    const handleExportAllCustomer = async () => {
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api1/account/customerVerifiedToExport`, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Verified_customer_data_${date}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert('Export Customer Data successfully');
        } catch (error) {
            console.error('Error generating export:', error.response?.data || error.message);
            alert('Export Customer Data failed');
        } finally {
            setIsDownloading(false);
        }
    };

    // search filter API 
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchOption && searchInput) {
            let url = '';
            switch (searchOption) {
                case 'borrower_name':
                    url = `${base_url}/api1/account/verifiedSearchByBorrowerName?borrowerName=${searchInput}`;
                    break;
                case 'borrower_id':
                    url = `${base_url}/api1/account/verifiedCustomerById?id=${searchInput}`;
                    break;
                case 'phone':
                    url = `${base_url}/api1/account/verifiedSearchByMobileNumber?mobileNumber=${searchInput}`;
                    break;
                default:
                    break;
            }
            axios.get(url).then(
                (response) => {
                    console.log(response.data);
                    setCustomer(response.data);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    // search filter API end 

    const indexOfLastCustomer = currentPage * customersPerPage;
    const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;
    const Customers = customer.slice(indexOfFirstCustomer, indexOfLastCustomer);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const totalPages = Math.ceil(customer.length / customersPerPage);

    const maxPageButtons = 10;

    const getPaginationRange = () => {
        const midPoint = Math.ceil(maxPageButtons / 2);
        let startPage = currentPage - midPoint + 1;
        let endPage = startPage + maxPageButtons - 1;

        if (startPage <= 0) {
            startPage = 1;
            endPage = Math.min(totalPages, maxPageButtons);
        } else if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, endPage - maxPageButtons + 1);
        }

        return { startPage, endPage };
    };

    const { startPage, endPage } = getPaginationRange();

    return (
        <>
            <div className='overviewsaa'>
                <h4>Customer Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            <div className='row'>
                                                <div className="col-md-3 col-3">
                                                    <div className=" required">
                                                        <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required="required">
                                                            <option value="" selected="selected">Search By</option>
                                                            <option value="borrower_name">Borrower Name</option>
                                                            <option value="borrower_id">Partner Id</option>
                                                            <option value="phone">Phone</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 col-6">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required/>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 col-3">
                                                    <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                </div>
                                                {/* <div className="col-md-2">
                                                    <div className='resion'>
                                                        <NavLink to="#" className="FaArrowAltCircleUp exportbutton" onClick={handleShow}>Upload <FaArrowAltCircleUp /></NavLink>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-2 mt-2">
                                                    <div className="export">
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportAllCustomer}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                Export  <FaDownload />
                                                                </>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='allcustomer table-responsive mb-5 mt-3'>
                                        { pageLoading ? <PageLoader text="Loading..." /> : Customers.length > 0  ? (
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>S.No.</th>
                                                        <th>Emp_Id</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Phone_Number</th>
                                                        <th>Accrued_Salary</th>
                                                        <th>Loan_Amount</th>
                                                        <th>Account_Number</th>
                                                        <th>Date_of_Birth</th>
                                                        <th>Status</th>
                                                        <th>View</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Customers.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.customerId}</td>
                                                            <td>{data.empId}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.salary}</td>
                                                            <td>{data.loanAmount}</td>
                                                            <td>{data.aadharNumber}</td>
                                                            <td>{data.dob}</td>
                                                            <td>{data.status}</td>
                                                            <td className='iconss'>
                                                                <NavLink to={`/operation/ViewVerifiedCustomer?id=${encodeURIComponent(data.customerId)}`}> <FaEyeSlash /></NavLink>
                                                            </td>
                                                            
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p>No All Verified Customer</p>
                                        )}
                                    </div>
                                    <div className='pagination mb-5'>
                                        {startPage > 1 && (
                                            <>
                                                <button onClick={() => paginate(1)}>1</button>
                                                <span>...</span>
                                            </>
                                        )}
                                        {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                                            <button
                                                key={startPage + i}
                                                onClick={() => paginate(startPage + i)}
                                                className={currentPage === startPage + i ? 'active' : ''}
                                            >
                                                {startPage + i}
                                            </button>
                                        ))}
                                        {endPage < totalPages && (
                                            <>
                                                <span>...</span>
                                                <button onClick={() => paginate(totalPages)}>{totalPages}</button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VerifiedCustomer;
